<template>
    <div class="homeHeader xy-center">
        <div class="container xy-between">
            <div class="left jf">
                <img
                    v-if="userInfo && userInfo.Logo"
                    :src="userInfo.Logo"
                    alt=""
                />
                <img v-else src="@/assets/img/headerLogo.png" alt="" />
                <div class="jf">
                    <div class="font-size22 text">
                        {{
                            userInfo.OrganName ? userInfo.OrganName : "朗润数据"
                        }}
                    </div>
                    <div class="dote"></div>
                    <div class="font-size22 text">
                        {{
                            userInfo.PlatformName
                                ? userInfo.PlatformName
                                : "医学培训考试服务平台"
                        }}
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="userInfoBox xy-center">
                    <div v-if="!isShowUserName" class="userInfo jf">
                        <!-- <div class="avtor"></div> -->
                        <div
                            class="loginText font-size14 c-2F3134"
                            @click="loginBtn"
                        >
                            <span>登录</span>
                            <span>&nbsp;|&nbsp;</span>
                            <span>注册</span>
                        </div>
                    </div>
                    <template v-else>
                        <div  class="userInfo jf userInfoHaveLogin">
                            <div class="avtor">
                                <img src="@/assets/img/defaulteActor.png" alt="" />
                            </div>
                            <div class="loginText font-size16 c-2F3134">
                                <div class="UserName one-wrap font-size14">
                                    {{ isPhoneNumber(userInfo.UserName) }}
                                    <i class="el-icon-caret-bottom"></i>
                                </div>
                            </div>
                            <div class="toPersonCenter">
                                <router-link
                                    v-for="item in profileRoutes"
                                    :to="item.Path === '/manage/psq' ? item.Path : (item.children && item.children.length) ? item.children[0].Path : item.Path"
                                    :key="item.Path"
                                    class="font-size14 centerTextBtn threedary jf cursor">
<!--                                    <i class="el-icon-user c-32353A"></i>-->
                                    {{item.Name}}
                                </router-link>
                                <div
                                    class="logOutbtn font-size14 threedary jf cursor text-center"
                                    @click="loginOut">
<!--                                    <i class="el-icon-s-unfold c-32353A"></i>-->
                                    退出
                                </div>
                            </div>
                        </div>
                       <div class="change-user" @click.stop="changeUserRole">
                           <div class="btn">{{$store.state.userInfo.isManage ? "前往用户端" : "前往管理端"}} <i class="el-icon-sort sort-icon"/></div>
                       </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { loginOut, UserInfo, changeUserRole } from "@/api/user";

export default {
    name: "ManageHeader",
    components: {},
    props: {
        state: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            isShowHeader: true,
            userInfo: {},
            isShowUserName: false
        };
    },
    computed: {
        profileRoutes () {
            console.log(this.$store.state.profileRoutes, "this.$store.state.profileRoutes");
            return this.$store.state.profileRoutes
        }
    },

    created() {
        this.judgeIsLogin();
    },
    mounted() {},
    destroyed() {},
    watch: {
        state(val) {
            this.userInfo = JSON.parse(val);
            this.isShowUserName = true;
        }
    },
    methods: {
        async goOut() {
            try {
                const { data } = await loginOut();
                this.isShowUserName = false;
                this.$store.commit("setUser", null);
                this.$store.commit("setUserInfo", null);
                window.location.href = window.location.pathname
            } catch (err) {
                console.log(error);
            }
        },
        judgeIsLogin() {
            let info = this.$store.state.userInfo;
            if (!info) {
                return;
            }
            if (info === "null") {
                this.isShowUserName = false;
            } else {
                this.isShowUserName = true;
                this.userInfo = info;
            }
        },
        goTopicLibary() {
            this.$router.push("/question/public");
        },
        goHome() {
            this.$router.push("/");
        },
        loginBtn() {
            this.$emit("openLoginDiolog");
        },
        isPhoneNumber(tel) {
            var reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/;
            if (reg.test(tel)) {
                tel = tel.substr(0, 3) + "****" + tel.substr(7);
                return tel;
            } else {
                return tel;
            }
        },
        goExam() {
            if (this.$store.getters.isLogin) {
                this.$router.push("/exam");
            }

        },

        loginOut() {
            this.$confirm(`是否确认退出${this.$store.state.userInfo.PlatformName}?`, "提示", {
                confirmButtonText: "确认退出",
                cancelButtonText: "我再想想",
                type: "warning"
            })
                .then(() => {
                    this.goOut();
                })
                .catch(() => {});
        },
        // 切换用户角色
        changeUserRole () {
            changeUserRole(0).then(res => {
                this.$store.commit("setUser", res);
                this.UserInfo().then(res => {
                    window.location.href = window.location.pathname
                })
            })
        },
        async UserInfo() {
            try {
                const { data } = await UserInfo();
                this.$store.commit("setUserInfo", data.data);
                let val = JSON.stringify(data.data);
                this.$emit("changeLoginState", val);
            } catch (err) {
                this.$message({
                    type: "error",
                    message: `获取用户信息失败`
                });
            }
        },
    }
};
</script>

<style scoped lang="less">
.homeHeader {
    width: 100%;
    height: 70px;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    background: white;
    box-shadow: rgb(204, 204, 204) 1px 1px 11px;

    .container {
        width: 62.5%;

        .left {
            img {
                width: 25px;
                margin-right: 10px;
            }

            .dote {
                background-color: black;
            }

            .text {
                font-size: 22px;
                font-weight: 600;
            }
        }

        .right {
            color: white;
            display: flex;
            justify-content: flex-end;

            .ulDeltDote {
                padding: 0;
                width: 300px;
                display: flex;
                margin-right: 60px;

                li {
                    cursor: pointer;
                    height: 30px;
                    width: 80px;
                }

                li:not(:first-child) {
                    margin-left: 40px;
                }

                .shouye {
                    color: #256cf4;

                    .line {
                        width: 20px;
                        height: 6px;
                        background: #256cf4;
                        border-radius: 3px;
                    }
                }
            }

            .userInfoBox {
                //width: 250px;
            }

            .userInfo {
                .avtor {
                    margin-right: 5px;
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    background: #efefef;
                    border: 1px solid #ffffff;

                    img {
                        width: 100%;
                    }
                }

                .loginText {
                    cursor: pointer;
                }

                .UserName {
                    max-width: 200px;
                }
            }

            .userInfoHaveLogin {
                position: relative;
                height: 50px;

                .toPersonCenter {
                    display: none;
                    min-width: 130px;
                    background-color: white;
                    position: absolute;
                    text-align: center;
                    top: 50px;
                    right: 0;
                    border-radius: 6px;
                    overflow: hidden;

                    a {
                        text-decoration: none;
                        display: block;
                    }

                    .centerTextBtn {
                        //width: 100%;
                        height: 40px;
                        padding: 10px;
                        box-sizing: border-box;
                        border-bottom: 1px solid #f0f3f7;

                        i {
                            margin-right: 10px;
                        }
                    }

                    .centerTextBtn:hover {
                        background-color: #f0f3f7;
                    }

                    .logOutbtn {
                        width: 100%;
                        height: 40px;
                        box-sizing: border-box;
                        text-align: center;
                        display: block;
                        line-height: 40px;

                        i {
                            margin-right: 10px;
                        }
                    }

                    .logOutbtn:hover {
                        background-color: #f0f3f7;
                    }
                }
            }

            .userInfoHaveLogin:hover .toPersonCenter {
                display: block;
                box-shadow: 0px 2px 40px 0px rgba(229, 232, 236, 0.8);
            }
        }
    }
}
.change-user {
    margin-left: 30px;
    .btn {
        padding: 9px 8px;
        color: #0C95FD;
        box-sizing: border-box;
        font-size: 14px;
        cursor: pointer;
        border: 1px solid #0C95FD;
        border-radius: 6px;
        transition: color .3s, background-color .3s;
        .sort-icon {
            transform: rotate(90deg);
            margin-left: 8px;
        }
        &:hover {
            background-color: #0C95FD;
            color: #fff;
        }
    }
}
</style>
